import { useState } from "react";
import ContactClasses from "./Login.module.css";
import Layout from "Components/Layouts/Common/common";
import { useForm, SubmitHandler } from "react-hook-form";
import CustomButton from "Components/Button";
import { NavLink } from "react-router-dom";
import { PiEyeClosedBold, PiEyeSlash } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import ApiService from "Services/config";
import { Login } from "Services/Requests";
import { ProgressBar } from "react-loader-spinner";

type Inputs = {
    email: string;
    password: string;
};
function Contact() {
    const navigate = useNavigate();
    const [errorMessage, setErrorMsg] = useState("");
    const [Loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const {
        register,
        handleSubmit,
        watch,
        formState: { errors },
    } = useForm<Inputs>();
    const onSubmit: SubmitHandler<Inputs> = async (data) => {
        try {
            const response = await Login(data);
            setLoading(false);
            console.log(response.data.user);
            if (response?.data?.message === "Login successful") {
                // setError("");
                ApiService.defaults.headers.common[
                    "Authorization"
                ] = `Bearer ${response?.data?.Token}`;
                localStorage.setItem("Token", response?.data?.Token);
                localStorage.setItem(
                    "UserDetails",
                    JSON.stringify(response?.data?.user)
                );
                navigate("/auth/dashboard");
            } else {
                setErrorMsg(response?.data?.Message);
            }
        } catch (err: any) {
            setLoading(false);
            console.log(err);
            setErrorMsg(
                err?.response?.data?.Message ||
                    err?.response?.data?.message ||
                    "Something went wrong try again later"
            );
        }
    };
    return (
        <Layout>
            <div className={ContactClasses["Container"]}>
                <header>
                    <h3>Login</h3>
                </header>
                <div className={ContactClasses["Form_wrapper"]}>
                    <h3>Sign In</h3>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className={ContactClasses["form-control"]}>
                            <label htmlFor="">Email ID</label>
                            <input
                                type="email"
                                placeholder="Enter your Email"
                                {...register("email", { required: true })}
                            />
                            {errors.email && <p>Email is required</p>}
                        </div>

                        <div className={ContactClasses["form-control"]}>
                            <label htmlFor="">Password</label>
                            <div className={ContactClasses["input-wrapper"]}>
                                <input
                                    type={show ? "text" : "password"}
                                    placeholder="Enter Your Password"
                                    {...register("password", {
                                        required: true,
                                    })}
                                />
                                <button
                                    type="button"
                                    onClick={() => setShow((prev) => !prev)}>
                                    {!show ? (
                                        <PiEyeClosedBold />
                                    ) : (
                                        <PiEyeSlash />
                                    )}
                                </button>
                            </div>
                            {errors.password && <p>Password is required</p>}
                        </div>
                        {errorMessage && (
                            <p className={ContactClasses["login-error"]}>
                                {errorMessage}
                            </p>
                        )}

                        <p style={{ textAlign: "left" }}>
                            forgot password?
                            <NavLink to={"/reset-password"}>Reset</NavLink>
                        </p>
                        {Loading ? (
                            <div
                                style={{
                                    gridColumn: "1/-1",
                                    justifySelf: "center",
                                }}>
                                <ProgressBar
                                    visible={true}
                                    height="80"
                                    width="80"
                                    barColor="#ccc"
                                    borderColor="lightblue"
                                    ariaLabel="progress-bar-loading"
                                    wrapperStyle={{}}
                                    wrapperClass=""
                                />
                                {/* <button type=""></button> */}
                            </div>
                        ) : (
                            <CustomButton
                                Title="Continue"
                                Theme="Dark"
                                type="submit"
                            />
                        )}

                        <p>
                            Don't Have an Account?
                            <NavLink to={"/sign-up"}> Signup</NavLink>
                        </p>
                    </form>
                </div>
            </div>
        </Layout>
    );
}

export default Contact;
